import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { EmptyState } from "@/components/common/EmptyState";
import { ShieldAlert, Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-fundio-bg">
        <Loader2 className="h-6 w-6 animate-spin text-fundio-gold" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export function RequireModule({ module, children }) {
  const { can } = useAuth();
  const { t } = useTranslation();
  if (!can(module, "read")) {
    return (
      <EmptyState
        icon={ShieldAlert}
        title={t("access.noAccessTitle")}
        description={t("access.noAccessModuleDesc")}
        testid="no-access-state"
      />
    );
  }
  return children;
}

export function RequireSuperAdmin({ children }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (user?.role !== "super_admin") {
    return (
      <EmptyState
        icon={ShieldAlert}
        title={t("access.noAccessTitle")}
        description={t("access.noAccessSuperDesc")}
        testid="no-access-state"
      />
    );
  }
  return children;
}

export function RequireRoles({ roles, children }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (!roles.includes(user?.role)) {
    return <EmptyState icon={ShieldAlert} title={t("access.noAccessTitle")} description={t("access.noAccessSuperDesc")} testid="no-access-state" />;
  }
  return children;
}

